import {Button} from "@consta/uikit/Button";
import {FunctionComponent} from "react";
import {useNavigate} from "react-router-dom";
import styles from './Unavailable.module.css';
import Header from "../../components/Header";
import {Footer} from "../../components/Footer";
import {Responses503} from "@consta/uikit/__internal__/src/components/Responses503";


export const Unavailable: FunctionComponent = () => {
    const navigate = useNavigate();
    return (
        <>
            <Header/>
            <Responses503
                className={styles.Error}
                title="Технические работы"
                description="Мы работаем над улучшением сервиса, пожалуйста, попробуйте позже"
                actions={
                    <Button view="ghost" label="Обновить" onClick={() => navigate(-1)}/>
                }
            />
            <Footer/>
        </>
    );
}